(function () {
  const replacements = [
    {
      match: 'カートに追加する',
      replacement: '単品をカートに追加する',
      // skip if already replaced
      skipIf: '単品をカートに追加する',
    },
    {
      match: '今すぐ購入',
      replacement: '単品購入をする',
      skipIf: '単品購入をする',
    },
  ];

  const applyReplacements = (str) => {
    let result = str;
    for (const { match, replacement, skipIf } of replacements) {
      if (result.includes(skipIf)) continue;
      result = result.split(match).join(replacement);
    }
    return result;
  };

  let isReplacing = false;

  const replaceText = (root) => {
    if (isReplacing) return;
    isReplacing = true;
    try {
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        const updated = applyReplacements(node.nodeValue);
        if (updated !== node.nodeValue) node.nodeValue = updated;
      }
    } finally {
      setTimeout(() => { isReplacing = false; }, 0);
    }
  };

  const watch = (container) => {
    replaceText(container);

    let scheduled = false;
    const observer = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        replaceText(container);
      });
    });

    observer.observe(container, {
      childList: true,
      subtree: true,
    });
  };

  const tryStart = () => {
    const el = document.getElementsByClassName('product__cart-functions')[0];
    if (el) {
      watch(el);
      return true;
    }
    return false;
  };

  if (tryStart()) return;

  const waitObserver = new MutationObserver(() => {
    if (tryStart()) waitObserver.disconnect();
  });

  waitObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  setTimeout(() => waitObserver.disconnect(), 10000);
})();
